import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class KaiziqResolveConnectionAnalyticsService {

    constructor(){

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);
        
        this.KAIZIQ_RESOLVE_CONNECTION_ANALYTICS = '/api/kaiziq-resolve-connection-analytics';

        this.GET_BY_FORM_ID = '/formId/{formId}';
        this.GET_LIST_FOR_PROJECT = '/list/project/{projectId}';

    }


    async getByFormId(formId){
        let url = window.location.origin + this.KAIZIQ_RESOLVE_CONNECTION_ANALYTICS + this.GET_BY_FORM_ID;
        url = url
            .replace('{formId}', formId);
        try {
            return this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err)
        }
    }

    async getListByProject(projectId){
        let url = window.location.origin + this.KAIZIQ_RESOLVE_CONNECTION_ANALYTICS + this.GET_LIST_FOR_PROJECT;
        url = url
            .replace('{projectId}', projectId);
        try {
            return this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err)
        }
    }
}

export default KaiziqResolveConnectionAnalyticsService;
